import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "../../../../components/commonComponent/Form";
import { FIELDS, MODE } from "../../../../constants/SiteConstants";
import "../../../../styles/Form.css";

const API_URL = process.env.REACT_APP_API_URL;

const AddBlogCategory = () => {
  const navigate = useNavigate();

  const fields = [
    {
      label: FIELDS.NAME,
      name: "name",
      placeholder: "Enter Name",
      required: true,
    },
    {
      label: FIELDS.SLUG,
      name: "slug",
      placeholder: "Enter Slug",
      required: true,
    },
  
  ];

  const addBlogCategory = async (formData) => {
    try {
      const response = await axios.post(
        `${API_URL}/blogcategory/addblogcategory`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error adding blog:", error);
      throw error;
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await addBlogCategory(formData);
      toast.success("Data added successfully", {
        autoClose: 1000,
      });
      navigate("/blog-category");
    } catch (error) {
      toast.error("Error adding data", {
        autoClose: 1000,
      });
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Blog Category
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/blog-category")}
        >
          &times;
        </button>
      </div>
      <Form mode={MODE.ADD} onSubmit={handleSubmit} fields={fields} />
    </div>
  );
};

export default AddBlogCategory;
